import type { IconData } from '@stacksjs/iconify-core'

export const padlockAltOpen: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6 18a4 4 0 1 0 0-8a4 4 0 0 0 0 8M2 9.528V4a4 4 0 1 1 8 0v1a1 1 0 1 1-2 0V4a2 2 0 1 0-4 0v4.341a6 6 0 1 1-2 1.186zM6 16a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default padlockAltOpen
